import LoadingInner from "@/components/Loading";
import Match from "@/components/Match";
import MatchRoundHeader from "@/components/MatchRoundHeader";
import useBangKeoMatches from "@/hooks/useBangKeoMatches";
import { useEffect, useMemo, useRef } from "react";
import NoData from "@/components/NoData";
import { useLiveData } from "@/hooks/useLiveData";
import { useLiveUpdates } from "@/hooks/useLiveUpdates";

export default function MatchRound({
  leagueId,
  round,
  isCup = false,
  currentRound,
}) {
  const queryObject = useMemo(
    () => ({
      include: "homeTeam,awayTeam,odd,countOtherOdds,stats,events,insight",
      filterInclude: `leagueId:${leagueId},round:${round}`,
      filterOdds: -1,
      showEmptyOdds: 1,
      cache: false,
      page: 1,
      limit: 50,
    }),
    [leagueId, round]
  );

  const { leaguesWithMatches, loading } = useBangKeoMatches(queryObject);
  const { clearAllData } = useLiveData();

  const matchIds = useMemo(
      () =>
        leaguesWithMatches.flatMap(
          (league) => league.matches?.map((match) => match.id) || [],
        ),
      [leaguesWithMatches],
  );

  // live updates for all match IDs
  const stableMatchIds = useMemo(() => {
    const ids = matchIds.filter((id) => id != null);
    return Array.from(new Set(ids)).sort((a, b) => a - b);
  }, [matchIds]);

  const lastNonEmptyMatchIdsRef = useRef([]);
  useEffect(() => {
    if (stableMatchIds.length) {
      lastNonEmptyMatchIdsRef.current = stableMatchIds;
    }
  }, [stableMatchIds]);

  const matchIdsForLiveUpdates =
    stableMatchIds.length ? stableMatchIds : lastNonEmptyMatchIdsRef.current;

  useLiveUpdates(matchIdsForLiveUpdates);
  // clear match data live 
  useEffect(() => {
    return () => {
      clearAllData();
    };
  }, [clearAllData]);

  if (loading) return <LoadingInner />;

  if (!leaguesWithMatches[0]?.matches?.length) {
    return currentRound === round ? (
      <NoData message="Không có trận đấu nào" />
    ) : null;
  }

  return (
    <div className="mb-6">
      <MatchRoundHeader title={`${isCup ? "" : "Vòng"} ${round}`} />

      <div className="flex flex-col gap-2 mt-1">
        {leaguesWithMatches[0].matches.map((match) => (
          <Match key={match.id} match={match} />
        ))}
      </div>
    </div>
  );
}
